import React from "react";
import styled from "styled-components";

const CardContainer = styled.div`
  width: 140px;
`;

const TopBox = styled.div`
  width: 140px;
  height: 88px;
  border: 2px solid #e4e7ec;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  overflow: hidden;
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const BottomBox = styled.div`
  width: 100%;
  border: 2px solid #e4e7ec;
  border-radius: 8px;
  background: #ffffff;
  padding: 8px;
  
`;

const Title = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #182230;
`;

const Points = styled.div`
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
  color: #f79009; /* orange */
`;

const Expire = styled.div`
  margin-top: 4px;
  font-size: 10px;
  color: #667085; /* gray */
`;

function truncateText(text, maxLength) {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}

const CouponCard = ({ image, title, pointsText, expireText }) => {
  const displayTitle = truncateText(title, 20);
  return (
    <CardContainer>
      <TopBox>{image && <Logo src={image} alt={title || "coupon"} />}</TopBox>
      <BottomBox>
        {title && <Title title={title}>{displayTitle}</Title>}
        {pointsText && <Points>{pointsText}</Points>}
        {expireText && <Expire>{expireText}</Expire>}
      </BottomBox>
    </CardContainer>
  );
};

export default CouponCard;
